import React from 'react';
import { Box, Pagination, Select, MenuItem, Typography } from '@mui/material';

const PaginationBar = ({
    count,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions = [10, 25, 50],
}) => {
    const totalPages = Math.ceil(count / rowsPerPage);
    const from = count === 0 ? 0 : page * rowsPerPage + 1;
    const to = Math.min((page + 1) * rowsPerPage, count);

    const handlePageChange = (event, value) => {
        // Pagination component is 1-indexed, convert to 0-indexed
        onPageChange(event, value - 1);
    };

    const handleRowsPerPageChange = (event) => {
        onRowsPerPageChange(event);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 1,
                py: 1.5,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" color="text.secondary">
                    Rows per page:
                </Typography>
                <Select
                    size="small"
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    sx={{ minWidth: 60 }}
                >
                    {rowsPerPageOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </Box>

            <Typography variant="body2" color="text.secondary">
                {`${from}-${to} of ${count}`}
            </Typography>

            <Pagination
                count={totalPages}
                page={page + 1}
                onChange={handlePageChange}
                shape="rounded"
                color="primary"
                showFirstButton
                showLastButton
            />
        </Box>
    );
};

export { PaginationBar };
